import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';
import { supportedMetricsSelector } from '@store/common/selectors';
import { METRIC_WIDGET_METRICS } from '@src/utils/kpi';

const selector = (state) => get(state, SCOPE);

export const dropdownMetricsSelector = createSelector(
  supportedMetricsSelector,
  (supportedMetrics) => {
    return METRIC_WIDGET_METRICS;
  },
);

export const metricDataSelector = createSelector(selector, (metricData) => {
  return metricData;
});

export const loadingSelector = createSelector(selector, (metricDataState) => ({
  loading: metricDataState.isFetching,
  showError: metricDataState.errorCode !== 0,
  errorMsg: metricDataState.errorMsg,
}));

export default selector;
